"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.boards = void 0;
var utils_1 = require("../../utils");
var boardsUrl = '/boards';
exports.boards = function (axios) {
    return {
        // [boards]
        // モール別全体掲示板照会
        getBoards: function (getBoardsRequest) {
            return axios.get(boardsUrl, getBoardsRequest);
        },
        putBoardsBoardNoPosts: function (putBoardsBoardNoPostsRequest) {
            var url = utils_1.paramPathchange(boardsUrl + "/{boardNo}/posts", putBoardsBoardNoPostsRequest);
            return axios.put(url, putBoardsBoardNoPostsRequest.data);
        },
        getBoardsBoardNoPosts: function (getBoardsBoardNoPostsRequest) {
            var url = utils_1.paramPathchange(boardsUrl + "/{boardNo}/posts", getBoardsBoardNoPostsRequest);
            return axios.get(url, getBoardsBoardNoPostsRequest);
        },
        postBoardsBoardNoPosts: function (postBoardsBoardNoPostsRequest) {
            var url = utils_1.paramPathchange(boardsUrl + "/{boardNo}/posts", postBoardsBoardNoPostsRequest);
            return axios.post(url, postBoardsBoardNoPostsRequest.data);
        },
        deleteBoardsBoardNoPosts: function (deleteBoardsBoardNoPostsRequest) {
            var url = utils_1.paramPathchange(boardsUrl + "/{boardNo}/posts", deleteBoardsBoardNoPostsRequest);
            return axios.delete(url, deleteBoardsBoardNoPostsRequest);
        },
        getBoardsBoardNoPostsPostNoReplies: function (getBoardsBoardNoPostsPostNoRepliesRequest) {
            var url = utils_1.paramPathchange(boardsUrl + "/{boardNo}/posts/{postNo}/replies", getBoardsBoardNoPostsPostNoRepliesRequest);
            return axios.get(url, getBoardsBoardNoPostsPostNoRepliesRequest);
        },
        getBoardsBoardNoPostsPostNoRepliesV2: function (getBoardsBoardNoPostsPostNoRepliesRequest) {
            var url = utils_1.paramPathchange(boardsUrl + "/{boardNo}/posts/{postNo}/replies", getBoardsBoardNoPostsPostNoRepliesRequest);
            return axios.get(url, getBoardsBoardNoPostsPostNoRepliesRequest);
        },
        getBoardsBoardNoPostsPostNo: function (getBoardsBoardNoPostsPostNoRequest) {
            var url = utils_1.paramPathchange(boardsUrl + "/{boardNo}/posts/{postNo}", getBoardsBoardNoPostsPostNoRequest);
            return axios.get(url, getBoardsBoardNoPostsPostNoRequest);
        },
        getBoardsBoardNoPostsPostNoV2: function (getBoardsBoardNoPostsPostNoRequest) {
            var url = utils_1.paramPathchange(boardsUrl + "/{boardNo}/posts/{postNo}", getBoardsBoardNoPostsPostNoRequest);
            return axios.get(url, __assign(__assign({}, getBoardsBoardNoPostsPostNoRequest), { headers: { Version: '1.1' } }));
        },
        putBoardsBoardNoPostsPostNo: function (putBoardsBoardNoPostsPostNoRequest) {
            var url = utils_1.paramPathchange(boardsUrl + "/{boardNo}/posts/{postNo}", putBoardsBoardNoPostsPostNoRequest);
            return axios.put(url, putBoardsBoardNoPostsPostNoRequest.data);
        },
        // 掲示板作成
        postBoards: function (postBoardsRequest) {
            return axios.post('/boards', postBoardsRequest.data);
        },
        // 掲示板内訳照会
        getBoardsDetail: function (getBoardsDetailRequest) {
            return axios.get("/boards/" + getBoardsDetailRequest.params.boardNo, getBoardsDetailRequest);
        },
        // 掲示板削除
        deleteBoards: function (deleteBoardsRequest) {
            return axios.delete("/boards/" + deleteBoardsRequest.params.boardNo, deleteBoardsRequest);
        },
        // 掲示板修正
        putBoardsDetail: function (putBoardsDetailRequest) {
            return axios.put("/boards/" + putBoardsDetailRequest.params.boardNo, putBoardsDetailRequest.data);
        },
        // 掲示板順序修正
        putBoardsOrder: function (putBoardsRequest) {
            return axios.put("/boards/" + putBoardsRequest.params.boardNo + "/order", putBoardsRequest.data);
        },
        getBoardsPostsCount: function (getBoardsPostsCountRequest) {
            var url = utils_1.paramPathchange(boardsUrl + "/{boardNo}/posts/count", getBoardsPostsCountRequest);
            return axios.get(url, getBoardsPostsCountRequest);
        },
        putCommonBoards: function (putCommonBoardsRequest) {
            return axios.put('/boards', putCommonBoardsRequest.data);
        },
        putCommonBoardsOrder: function (putCommonBoardsOrderRequest) {
            return axios.put('/boards/order', putCommonBoardsOrderRequest.data);
        }
    };
};
